var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{attrs:{"id":"jump-to-header"}},[_vm._v(_vm._s(_vm.heading || _vm.generated_heading + " Update"))]),_c('product-item-update',{attrs:{"id":_vm.id},on:{"gotAttrs":_vm.assignAttrs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }